import { IOptions, IPdfTronData, ISectionData } from '@modeso/aumico-lib-annualreport-fe';
import { GetOrganizationDto } from '@modeso/aumico-lib-users-fe';
import {
    AnnualReportStep,
    IAnnualReport,
    IComplementaryReport,
    IFinStatements,
    IPrintOptions,
} from '@modeso/types__aumico-lib-annualreport-be';
import { INameId } from '@modeso/types__aumico-lib-core-be';

export interface IPdfTronMapper {
    mapAnnualReportToPdfTronData(
        annualReport: IAnnualReport,
        finStatements: IFinStatements[],
        printOptions: IPrintOptions,
        organization: GetOrganizationDto | undefined,
        annualReportForAutofill: IAnnualReport,
        activeArNavigations: AnnualReportStep[],
        complementaryReportsTitles: string[],
        GICSCodesAndNames: INameId[],
        isFixedAssetsScheduleDataValid: boolean,
        predifinedLables: Map<string, string>,
        formatLocale: string,
        translationLocale: string,
        reportLocale: string,
        companyLogo: string | null,
        notesComponentsHTMLMap?: Map<string, Map<string, string>>,
    ): IPdfTronData;

    getSections(
        annualReport: IAnnualReport,
        printOptions: IPrintOptions,
        annualReportForAutofill: IAnnualReport,
        reportOrder: string[],
        options: IOptions,
        predifinedLables: Map<string, string>,
        formatLocale: string,
        translationLocale: string,
        reportLocale: string,
        complementaryReportsAsAppendix: IComplementaryReport[],
        finStatements: IFinStatements[],
    ): ISectionData[];

    mapComplementaryReportToSectionData(complementaryReport: IComplementaryReport,
        complementaryReportIndex: string,
    ): ISectionData;
}
